import React from "react";
import { Redirect, useLocation, useParams } from "react-router-dom";

import ProspectDemo from "./index";
import ProspectExamples from "./Examples";

// /demos/<slug>: the brand's own demo when there is one, otherwise the example business of that
// name (app.pivony.com/demos/saltleaf-tr). A brand demo always wins, so an example never hides one.
const ExampleOrMissing = ({ missing }) => <ProspectExamples missing={missing} />;

export const DemoRoute = () => <ProspectDemo NotFound={ExampleOrMissing} />;

// Example links shared before the short form (/demos/examples/<slug>).
export const ExampleRedirect = () => {
  const { slug } = useParams();
  const { search } = useLocation();
  return <Redirect to={`/demos/${encodeURIComponent(slug)}${search}`} />;
};
